import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import CutDetailsScreen from './app/screens/CutDetailsScreen';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Cairo, sans-serif',
  },
  palette: {
    primary: {
      main: '#782959', // اللون الأساسي
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#c75ca8', // درجة أفتح يمكن استخدامها للتأكيدات أو الأزرار الثانوية
    },
    background: {
      default: '#fafafa',
      paper: '#ffffff',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          textTransform: 'none',
          fontWeight: '600',
          fontSize: '1rem',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Cairo, sans-serif',
        },
      },
    },
  },
});

function App() {
  return (
        <ThemeProvider theme={theme}>

    <BrowserRouter>
      <Routes>
        {/* ✅ Route with phone as a URL parameter */}
        <Route path="/:code" element={<CutDetailsScreen />} />

        {/* Optional: route without phone */}
        <Route path="/" element={<CutDetailsScreen />} />
      </Routes>
    </BrowserRouter>
  </ThemeProvider>
  );
}

export default App;
